import { render, staticRenderFns } from "./CardReportV2.vue?vue&type=template&id=1ac324b6&scoped=true&lang=pug"
import script from "./CardReportV2.vue?vue&type=script&lang=js"
export * from "./CardReportV2.vue?vue&type=script&lang=js"
import style0 from "./CardReportV2.vue?vue&type=style&index=0&id=1ac324b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ac324b6",
  null
  
)

export default component.exports